import React from 'react';

const Terms = () => {
  return (
    <div className="min-h-screen pt-24">
      <section className="py-20 bg-surface">
        <div className="max-w-4xl mx-auto px-6">
          <h1 className="text-4xl sm:text-5xl font-serif font-bold text-primary tracking-tight mb-6">
            Algemene Voorwaarden
          </h1>
          <p className="text-sm text-muted-foreground">
            Laatst bijgewerkt: Januari 2026
          </p>
        </div>
      </section>

      <section className="py-12">
        <div className="max-w-4xl mx-auto px-6 space-y-8 text-muted-foreground leading-relaxed">
          <div>
            <h2 className="text-2xl font-serif font-semibold text-primary mb-4">
              1. Afspraken en Reserveringen
            </h2>
            <p>
              Afspraken kunnen online, telefonisch of via WhatsApp worden gemaakt. We doen ons best
              om alle afspraken op de afgesproken tijd te respecteren. Bij vertraging worden klanten
              zo snel mogelijk geïnformeerd.
            </p>
          </div>

          <div>
            <h2 className="text-2xl font-serif font-semibold text-primary mb-4">
              2. Annulering en Verzetten
            </h2>
            <p>
              We vragen u vriendelijk om minimaal <strong>24 uur van tevoren</strong> te annuleren of
              uw afspraak te verzetten. Dit kan telefonisch of via WhatsApp. Herhaaldelijk te laat
              annuleren of niet komen opdagen kan leiden tot beperking van toekomstige boekingen.
            </p>
          </div>

          <div>
            <h2 className="text-2xl font-serif font-semibold text-primary mb-4">
              3. Betaling
            </h2>
            <p>
              <strong>Betaling wordt in de salon geïnd na afloop van de behandeling.</strong> We
              accepteren contant en pinbetalingen. Er is geen online betaling vereist bij het maken
              van een afspraak.
            </p>
          </div>

          <div>
            <h2 className="text-2xl font-serif font-semibold text-primary mb-4">
              4. Allergieën en Gezondheid
            </h2>
            <p>
              Het is de verantwoordelijkheid van de klant om de stylist te informeren over eventuele
              <strong> allergieën, huidaandoeningen of medische condities</strong> voordat de
              behandeling begint. 4AN Hair & Beauty Studio kan niet aansprakelijk worden gesteld voor
              reacties die het gevolg zijn van het niet melden van allergieën.
            </p>
          </div>

          <div>
            <h2 className="text-2xl font-serif font-semibold text-primary mb-4">
              5. Kleurbehandelingen
            </h2>
            <p>
              <strong>Kleuren kunnen variëren</strong> afhankelijk van het haartype, de huidige
              haarkleur en de conditie van het haar. We bespreken altijd vooraf de verwachte
              resultaten, maar kunnen niet garanderen dat het resultaat exact overeenkomt met
              referentiebeelden. Haarreacties op kleurbehandelingen zijn individueel en buiten onze
              controle.
            </p>
          </div>

          <div>
            <h2 className="text-2xl font-serif font-semibold text-primary mb-4">
              6. Aansprakelijkheid
            </h2>
            <p>
              4AN Hair & Beauty Studio is niet aansprakelijk voor schade of ongewenste resultaten die
              het gevolg zijn van:
            </p>
            <ul className="list-disc pl-6 mt-2 space-y-1">
              <li>Het niet melden van allergieën of huidcondities</li>
              <li>Het niet opvolgen van nazorginstructies</li>
              <li>Natuurlijke haarvariaties en reacties op producten</li>
              <li>Persoonlijke bezittingen die verloren of beschadigd raken in de salon</li>
            </ul>
          </div>

          <div>
            <h2 className="text-2xl font-serif font-semibold text-primary mb-4">
              7. Gedragscode
            </h2>
            <p>
              We verwachten respectvol gedrag van alle klanten tegenover ons personeel en andere
              klanten. We behouden ons het recht voor om diensten te weigeren aan klanten die zich
              ongepast gedragen.
            </p>
          </div>

          <div>
            <h2 className="text-2xl font-serif font-semibold text-primary mb-4">
              8. Wijzigingen in Voorwaarden
            </h2>
            <p>
              We behouden ons het recht voor om deze algemene voorwaarden te wijzigen. Wijzigingen
              worden op onze website gepubliceerd en treden in werking vanaf de datum van
              publicatie.
            </p>
          </div>

          <div>
            <h2 className="text-2xl font-serif font-semibold text-primary mb-4">
              9. Contact
            </h2>
            <p>
              Voor vragen over deze voorwaarden kunt u contact met ons opnemen:
            </p>
            <p className="mt-2">
              <strong>4AN Hair & Beauty Studio</strong><br />
              Alfonse de cockplein 5A, 1831 Diegem<br />
              E-mail: info@4anhair.com<br />
              Telefoon: +32 473 18 39 27
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Terms;
